import(/* webpackMode: "eager" */ "/app/src/app/[locale]/Property-Construction/page.tsx");
